<template>
    <div class="search-bar">
        <el-input :placeholder="placeholder" v-model="search" class="search">
            <el-button slot="append" type="primary" @click="getSearch(search)">搜索</el-button>
        </el-input>
        <div class="right">
            <div class="item">
                <span class="label">{{ rightList[0] }}</span>
                <span class="value">¥{{ ordersPrice }}</span>
            </div>
            <div class="item">
                <span class="label">{{ rightList[1] }}</span>
                <span class="value">{{ count }}笔</span>
            </div>
            <div class="item excel">
                <span class="label">{{rightList[2]}}</span>
                <span class="value" @click="downExcel">
                    <i class="iconfont iconexcel"></i>
                    Excel格式
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'search',
  props: {
    ordersPrice: Number,
    count: Number,
  },
  inject: {
    getSearch: 'searchList',
    placeholder: 'searchPlaceholder',
    downExcel: 'downLoadExcel',
    rightList: 'rightList',
  },
  data() {
    return {
      search: '',
    };
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.el-input-group__append button.el-button {
  .button--primary(@primary-blue);
  color: @bg-white;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  height: 40px;
}

.search-bar {
  .reconciliation_list_space();
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 20px;
  .flex_layout(row, space-between);
  .search {
    width: 314px;
  }
}
.right {
  .flex_layout();
  .item {
    margin-right: 2.5em;
    font-weight: 500;
    &:last-child {
      margin-right: 0;
    }
    .label {
      color: #666666;
    }
    .value {
      color: @font-color-black;
    }
  }
  .excel .value {
    cursor: pointer;
    color: #43aab7;
  }
}
</style>
